import themeColorsDesingSystem from "assets/theme/ds-colors";

export const CONTENT_TABS = [
  { key: "TODOS", label: "Todos" },
  { key: "CAMPANHA", label: "Campanhas" },
  { key: "BANNER", label: "Banners" },
  { key: "LOOKBOOK", label: "Lookbooks" },
  { key: "VIDEO", label: "Vídeos" },
  { key: "MATERIAL", label: "Materiais" },
];

export const CONTENT_TYPES = [
  { value: "CAMPANHA", label: "Campanha" },
  { value: "BANNER", label: "Banner" },
  { value: "LOOKBOOK", label: "Lookbook" },
  { value: "VIDEO", label: "Vídeo" },
  { value: "MATERIAL_PDF", label: "Material PDF" },
  { value: "INSTITUCIONAL", label: "Institucional" },
  { value: "VM_MERCHANDISING", label: "VM / Merchandising" },
];

export const CONTENT_STATUS = [
  { value: "RASCUNHO", label: "Rascunho" },
  { value: "PUBLICADO", label: "Publicado" },
  { value: "AGENDADO", label: "Agendado" },
  { value: "EXPIRADO", label: "Expirado" },
  { value: "ARQUIVADO", label: "Arquivado" },
  { value: "EM_REVISAO", label: "Em revisão" },
];

export const SORT_OPTIONS = [
  { value: "recentes", label: "Mais recentes" },
  { value: "atualizados", label: "Últimos atualizados" },
  { value: "acessados", label: "Mais acessados" },
];

export const CAMPAIGN_CATEGORIES = [
  { value: "COMERCIAL", label: "Campanha Comercial" },
  { value: "INSTITUCIONAL", label: "Institucional" },
  { value: "COLECAO", label: "Coleção" },
  { value: "SAZONAL", label: "Sazonal" },
  { value: "DATAS_COMEMORATIVAS", label: "Datas comemorativas" },
  { value: "VM", label: "VM / Visual Merchandising" },
  { value: "TREINAMENTO", label: "Treinamento" },
  { value: "INCENTIVO", label: "Incentivo de vendas" },
];

export const MATERIAL_TYPES = [
  { value: "PDF", label: "PDF" },
  { value: "JPG", label: "JPG" },
  { value: "PNG", label: "PNG" },
  { value: "MP4", label: "MP4" },
  { value: "LINK", label: "Link externo" },
  { value: "ZIP", label: "ZIP" },
];

export const SEGMENTATION_OPTIONS = [
  { value: "TODAS", label: "Todas as franquias" },
  { value: "SUL", label: "Região Sul" },
  { value: "SUDESTE", label: "Região Sudeste" },
  { value: "NORTE", label: "Região Norte" },
  { value: "NORDESTE", label: "Região Nordeste" },
  { value: "CENTRO_OESTE", label: "Região Centro-Oeste" },
];

export const MOCK_CATEGORIES = [
  {
    id: 1,
    nome: "Campanha Comercial",
    descricao: "Campanhas de vendas e promoções",
    status: "ATIVO",
    ordem: 1,
    cor: "#5D5FEF",
  },
  {
    id: 2,
    nome: "Institucional",
    descricao: "Conteúdos institucionais da marca",
    status: "ATIVO",
    ordem: 2,
    cor: "#0AA836",
  },
  {
    id: 3,
    nome: "Coleção",
    descricao: "Lançamentos de coleções",
    status: "ATIVO",
    ordem: 3,
    cor: "#ff3709",
  },
  {
    id: 4,
    nome: "Sazonal",
    descricao: "Conteúdos sazonais",
    status: "ATIVO",
    ordem: 4,
    cor: "#ffd600",
  },
  {
    id: 5,
    nome: "VM / Merchandising",
    descricao: "Visual merchandising",
    status: "INATIVO",
    ordem: 5,
    cor: "#A0A4B3",
  },
];

export const MOCK_CONTENTS = [
  {
    id: 1,
    titulo: "Coleção Inverno 2026",
    descricao: "Campanha principal da coleção de inverno",
    tipo: "CAMPANHA",
    categoria: "Coleção",
    status: "PUBLICADO",
    dataInicio: "2026-03-01",
    dataFim: "2026-08-31",
    atualizadoPor: "Ana Marketing",
    dataAtualizacao: "2026-05-20",
    acessos: 342,
    thumbnail: "https://picsum.photos/seed/karsten1/80/60",
  },
  {
    id: 2,
    titulo: "Banner Dia das Mães",
    descricao: "Banner promocional para vitrine",
    tipo: "BANNER",
    categoria: "Datas comemorativas",
    status: "AGENDADO",
    dataInicio: "2026-05-01",
    dataFim: "2026-05-15",
    atualizadoPor: "Carlos Silva",
    dataAtualizacao: "2026-04-28",
    acessos: 128,
    thumbnail: "https://picsum.photos/seed/karsten2/80/60",
  },
  {
    id: 3,
    titulo: "Lookbook Verão 2026",
    descricao: "Catálogo visual da coleção verão",
    tipo: "LOOKBOOK",
    categoria: "Coleção",
    status: "PUBLICADO",
    dataInicio: "2026-01-15",
    dataFim: "2026-06-30",
    atualizadoPor: "Ana Marketing",
    dataAtualizacao: "2026-05-18",
    acessos: 567,
    thumbnail: "https://picsum.photos/seed/karsten3/80/60",
  },
  {
    id: 4,
    titulo: "Treinamento de Vendas Q2",
    descricao: "Vídeo de treinamento para equipes",
    tipo: "VIDEO",
    categoria: "Treinamento",
    status: "RASCUNHO",
    dataInicio: "2026-06-01",
    dataFim: "2026-09-30",
    atualizadoPor: "Juliana Costa",
    dataAtualizacao: "2026-05-25",
    acessos: 0,
    thumbnail: "https://picsum.photos/seed/karsten4/80/60",
  },
  {
    id: 5,
    titulo: "Manual de Merchandising",
    descricao: "PDF com diretrizes de exposição",
    tipo: "MATERIAL_PDF",
    categoria: "VM / Merchandising",
    status: "PUBLICADO",
    dataInicio: "2026-01-01",
    dataFim: "2026-12-31",
    atualizadoPor: "Pedro Alves",
    dataAtualizacao: "2026-05-10",
    acessos: 891,
    thumbnail: "https://picsum.photos/seed/karsten5/80/60",
  },
  {
    id: 6,
    titulo: "Campanha Black Friday 2025",
    descricao: "Materiais da campanha Black Friday",
    tipo: "CAMPANHA",
    categoria: "Campanha Comercial",
    status: "EXPIRADO",
    dataInicio: "2025-11-01",
    dataFim: "2025-11-30",
    atualizadoPor: "Ana Marketing",
    dataAtualizacao: "2025-12-01",
    acessos: 1204,
    thumbnail: "https://picsum.photos/seed/karsten6/80/60",
  },
  {
    id: 7,
    titulo: "Vídeo Institucional Karsten",
    descricao: "Apresentação da marca para franquias",
    tipo: "INSTITUCIONAL",
    categoria: "Institucional",
    status: "PUBLICADO",
    dataInicio: "2025-06-01",
    dataFim: "2027-06-01",
    atualizadoPor: "Carlos Silva",
    dataAtualizacao: "2026-03-15",
    acessos: 2156,
    thumbnail: "https://picsum.photos/seed/karsten7/80/60",
  },
  {
    id: 8,
    titulo: "Kit VM Loja Conceito",
    descricao: "Materiais de visual merchandising",
    tipo: "VM_MERCHANDISING",
    categoria: "VM / Merchandising",
    status: "EM_REVISAO",
    dataInicio: "2026-05-15",
    dataFim: "2026-12-31",
    atualizadoPor: "Juliana Costa",
    dataAtualizacao: "2026-05-27",
    acessos: 45,
    thumbnail: "https://picsum.photos/seed/karsten8/80/60",
  },
  {
    id: 9,
    titulo: "Banner Outlet Primavera",
    descricao: "Banner para campanha de outlet",
    tipo: "BANNER",
    categoria: "Sazonal",
    status: "ARQUIVADO",
    dataInicio: "2025-09-01",
    dataFim: "2025-10-31",
    atualizadoPor: "Pedro Alves",
    dataAtualizacao: "2025-11-05",
    acessos: 312,
    thumbnail: "https://picsum.photos/seed/karsten9/80/60",
  },
  {
    id: 10,
    titulo: "Catálogo de Produtos Q3",
    descricao: "Material PDF com produtos do trimestre",
    tipo: "MATERIAL_PDF",
    categoria: "Campanha Comercial",
    status: "AGENDADO",
    dataInicio: "2026-07-01",
    dataFim: "2026-09-30",
    atualizadoPor: "Ana Marketing",
    dataAtualizacao: "2026-05-22",
    acessos: 0,
    thumbnail: "https://picsum.photos/seed/karsten10/80/60",
  },
];

const { primary, secondary, green, orange, yellow, red, gray, stone } =
  themeColorsDesingSystem;

export const TYPE_STYLE = {
  CAMPANHA: { bg: `${primary.main}22`, color: primary.main },
  BANNER: { bg: `${secondary.main}44`, color: primary.dark },
  LOOKBOOK: { bg: `${secondary.main}33`, color: primary.main },
  VIDEO: { bg: orange.background, color: orange.main },
  MATERIAL_PDF: { bg: stone.light, color: gray.dark },
  INSTITUCIONAL: { bg: green.background, color: green.main },
  VM_MERCHANDISING: { bg: stone.main, color: gray.dark },
};

export const STATUS_STYLE = {
  RASCUNHO: { bg: stone.light, color: gray.dark },
  PUBLICADO: { bg: green.backgroundActive, color: green.main },
  AGENDADO: { bg: yellow.background, color: "#9a7b00" },
  EXPIRADO: { bg: red.background, color: red.main },
  ARQUIVADO: { bg: stone.light, color: gray.dark },
  EM_REVISAO: { bg: `${secondary.main}44`, color: primary.main },
};

export function getTypeLabel(tipo) {
  return CONTENT_TYPES.find((t) => t.value === tipo)?.label || tipo;
}

export function getStatusLabel(status) {
  return CONTENT_STATUS.find((s) => s.value === status)?.label || status;
}

export function formatPeriodo(dataInicio, dataFim) {
  if (!dataInicio && !dataFim) return "-";
  const format = (d) => {
    if (!d) return "";
    const [y, m, day] = d.split("-");
    return `${day}/${m}/${y}`;
  };
  return `${format(dataInicio)} à ${format(dataFim)}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return "-";
  const [y, m, day] = dateStr.split("-");
  return `${day}/${m}/${y}`;
}

export function matchesTab(tipo, tabKey) {
  if (tabKey === "TODOS") return true;
  if (tabKey === "MATERIAL") {
    return ["MATERIAL_PDF", "INSTITUCIONAL", "VM_MERCHANDISING"].includes(tipo);
  }
  return tipo === tabKey;
}
